<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div class="mg-x-50 pd-20 mg-y-20">
        <div class="modal-content bd-0 tx-14">
          <modal-loading :show="loading"></modal-loading>
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ billSupplierName }} - {{ $t("financial.结算订单") }}
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pd-25">
            <div v-if="items && items.length > 0">
              <div class="form-group">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-left
                    tx-bold tx-gray-900
                  "
                  >{{ $t("financial.采购单") }}</label
                >
              </div>
              <!-- 表格 -->
              <div class="list-wrap">
                <!-- 表头 -->
                <div class="list-heard d-flex pd-y-6">
                  <div class="d-flex pd-x-5 flex-1">
                    <div class="c-6">
                      {{ $t("distributor.采购单信息") }}
                    </div>
                    <div class="c-4">{{ $t("rm.结算信息") }}</div>
                    <div class="c-5">{{ $t("financial.入库信息") }}</div>
                    <div class="c-5">{{ $t("warehouse.日期") }}</div>
                    <div class="c-4">{{ $t("financial.备注") }}</div>
                  </div>
                </div>
                <!-- 列表 -->
                <div
                  class="list-body d-flex mg-b-10"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <div class="flex-1 pd-x-5 product-table bd-gray-400 pd-5">
                    <!-- 采购单信息 -->
                    <div class="d-flex align-items-center">
                      <!-- 采购单信息 -->
                      <div
                        class="
                          c-6
                          valign-middle
                          tx-12
                          d-flex
                          align-items-center
                        "
                      >
                        <div>
                          <a
                            href="javascript:;"
                            class="tx-info tx-underline tx-14"
                          >
                            <i
                              class="mg-x-5 fa tx-14"
                              :class="
                                true ? 'fa-minus-square' : 'fa-plus-square'
                              "
                            ></i>
                          </a>
                        </div>
                        <div class="flex-1">
                          <!-- 订单号 -->
                          <div class="d-flex align-items-center">
                            <span>{{ $t("financial.订单号") }}:&nbsp;</span>
                            <router-link
                              class="tx-info"
                              target="_blank"
                              :to="{
                                path: '/order-manager',
                                query: { code: item.code },
                              }"
                              >{{ item.code }}</router-link
                            >
                          </div>
                        </div>
                      </div>
                      <!-- 结算信息 -->
                      <div class="c-4 valign-middle tx-12">
                        <!-- 商品金额 -->
                        <div class="d-flex align-items-center">
                          <span>{{ $t("financial.商品金额") }}:&nbsp;</span>
                          <span>{{ item.itemAmount }}</span>
                        </div>
                        <!-- 运费 -->
                        <div class="d-flex align-items-center">
                          <span>{{ $t("financial.运费") }}:&nbsp;</span>
                          <span>{{ item.shippingAmount }}</span>
                        </div>
                        <!-- 订单总额 -->
                        <div class="d-flex align-items-center">
                          <span>{{ $t("financial.订单总额") }}:&nbsp;</span>
                          <span>{{ item.totalAmount }}</span>
                        </div>
                      </div>
                      <!-- 入库信息 -->
                      <div class="c-5 valign-middle tx-12">
                        <!-- 入库日期 -->
                        <div class="d-flex align-items-center">
                          <span>{{ $t("financial.入库日期") }}:&nbsp;</span>
                          <span v-if="!item.timeStorage">---</span>
                          <span v-else>{{
                            item.timeStorage | formatDate
                          }}</span>
                        </div>
                      </div>
                      <!-- 日期 -->
                      <div class="c-5 valign-middle tx-12">
                        <!-- 采购日期 -->
                        <div class="mg-b-5 d-flex align-items-center">
                          <span>{{ $t("financial.采购日期") }}:&nbsp;</span>
                          <span>{{ item.timeCreated | formatDate }}</span>
                        </div>
                        <!-- 预计到货日期 -->
                        <div class="d-flex align-items-center">
                          <span>{{ $t("financial.预计到货日期") }}:&nbsp;</span>
                          <span v-if="!item.timeExpectedArrival">---</span>
                          <span v-else>{{
                            item.timeExpectedArrival | formatDate
                          }}</span>
                        </div>
                      </div>
                      <!-- 备注 -->
                      <div class="c-4 valign-middle tx-12">
                        <div class="d-flex align-items-center">
                          <span
                            v-if="item.illegalType != 0"
                            class="tx-danger"
                            >{{ illegalTypes[item.illegalType] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <!-- sku信息 -->
                    <div class="mg-l-20 mg-r-20 order-pro">
                      <!-- 列表 -->
                      <div
                        class="
                          valign-middle
                          tx-12
                          d-flex
                          align-items-center
                          mg-t-5 mg-b-5
                        "
                      >
                        <div
                          class="
                            c-12
                            d-flex
                            align-items-center
                            purchase-img-wrap
                          "
                        >
                          <!-- 图片 -->
                          <div class="pos-relative">
                            <a
                              href="javascript:;"
                              class="p-img-wrap pos-relative"
                              v-lazy:background-image=""
                            ></a>
                          </div>
                          <div style="width: calc(100% - 90px)">
                            <!-- 产品名称 -->
                            <p class="mg-b-5">
                              <span>{{ $t("financial.产品名称") }}:&nbsp;</span>
                              <span></span>
                            </p>
                            <!-- SKU -->
                            <p class="mg-b-5">
                              <span class="mg-r-5">SKU:&nbsp;</span>
                              <span class="tx-gray-300 mg-r-5">{{}}</span>
                              <a
                                href="javascript:;"
                                data-clipboard-text="testtesttestsku7"
                                class="to-clipboard tx-info mg-l-5"
                                ><i class="icon ion-clipboard"></i
                              ></a>
                            </p>
                            <!-- 属性 -->
                            <p class="mg-0">
                              <span>{{ $t("distributor.属性:") }}</span>
                              <span></span>
                            </p>
                          </div>
                        </div>
                        <div class="c-6">
                          <!-- 产品单价 -->
                          <p class="mg-0">
                            <span>{{ $t("product.产品单价") }}:&nbsp;</span>
                            <span></span>
                          </p>
                        </div>
                        <div class="c-6">
                          <!-- 未结算 -->
                          <p class="mg-b-5">
                            <span>{{ $t("dashboard.未结算") }}:&nbsp;</span>
                          </p>
                          <!-- 已结算 -->
                          <p class="mg-b-5">
                            <span>{{ $t("dashboard.已结算") }}:&nbsp;</span>
                          </p>
                          <!-- 总采购数 -->
                          <p class="mg-0">
                            <span>{{ $t("financial.总采购数：") }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="items.length == 0" class="nodata tx-center tx-16">
                <i class="fa fa-ban"></i>{{ $t("financial.没有数据 !") }}
              </div>
            </div>
            <div v-if="returnOrder && returnOrder.length > 0">
              <div class="form-group mg-t-15">
                <label
                  class="
                    col-md-2 col-sm-12 col-form-label
                    form-control-sm
                    text-left
                    tx-bold tx-gray-900
                  "
                  >{{ $t("financial.退货单") }}</label
                >
              </div>
              <table class="table table-striped mg-b-0">
                <thead>
                  <tr>
                    <td class="">
                      {{ $t("financial.退货单编号") }}
                    </td>
                    <td class="tx-center">{{ $t("financial.采购单编号") }}</td>
                    <td class="tx-center">{{ $t("financial.状态：") }}</td>
                    <td class="tx-center">
                      {{ $t("financial.货款 / 运费 / 实际应退总额") }}
                    </td>
                    <td class="tx-center">{{ $t("financial.退货时间") }}</td>
                    <td class="tx-center">{{ $t("financial.完成时间") }}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in returnOrder" :key="item.code">
                    <td class="valign-middle tx-12">
                      <router-link
                        class="tx-info"
                        target="_blank"
                        :to="{
                          path: '/order-return',
                          query: { code: item.code },
                        }"
                        >{{ item.code }}</router-link
                      >
                    </td>
                    <td class="valign-middle tx-center tx-12">
                      {{ item.orderCode ? item.orderCode : "---" }}
                    </td>
                    <td class="valign-middle tx-center tx-12">
                      <span
                        :class="item.status != 5 ? 'tx-warning' : 'tx-success'"
                        >{{ $t(showStatu(item.status)) }}</span
                      >
                    </td>
                    <td class="valign-middle tx-center tx-12">
                      <div>
                        {{ $t("financial.货款：")
                        }}<span class="">￥{{ item.itemAmount }}</span>
                      </div>
                      <div>
                        {{ $t("financial.运费：") }}
                        <span
                          v-if="
                            /1|2|3/.test(item.status) && item.shippingType == 2
                          "
                          class=""
                          >{{ $t("financial.尚未填写") }}</span
                        >
                        <span v-else class="">￥{{ item.shippingAmount }}</span>
                      </div>
                      <div>
                        {{ $t("financial.实际应退：")
                        }}<span class="">￥{{ item.totalAmount }}</span>
                      </div>
                    </td>
                    <td class="valign-middle tx-center tx-12">
                      <div>
                        <span :class="{ '': item.timeShipped }">
                          {{ item.timeShipped ? item.timeShipped : "----" }}
                        </span>
                      </div>
                    </td>
                    <td class="valign-middle tx-center tx-12">
                      <div>
                        <span :class="{ '': item.timeShipped }">
                          {{ item.timeFinished ? item.timeFinished : "----" }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <div class="tx-center">
              <button
                v-if="
                  (billStatus == 1 || billStatus == 2) &&
                  isSysRights('Bill.exportBySupplier')
                "
                type="button"
                class="
                  btn btn-primary
                  mg-r-5
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="openExport(billId)"
              >
                {{ $t("financial.导出采购单") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open"],
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      orderStatus: arrDict.orderStatus,
      items: [],
      billSupplierName: "",
      billSupplierId: "",
      billId: "",
      billStatus: "",
      returnOrder: [],
      illegalTypes: arrDict.illegalType,
      returnStatus: arrDict.returnStatus,
    };
  },
  components: {},
  computed: {},
  filters: {
    formatDate(val) {
      if (!val) return "----";
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    },
  },
  watch: {},
  created() {
    if (localStorage.getItem("openAllOrderListSu")) {
      if (JSON.parse(localStorage.getItem("openAllOrderListSu")).id > 0) {
        this.billSupplierName = JSON.parse(
          localStorage.getItem("openAllOrderListSu")
        ).supplierName;
        this.billSupplierId = JSON.parse(
          localStorage.getItem("openAllOrderListSu")
        ).supplierId;
        this.billId = JSON.parse(localStorage.getItem("openAllOrderListSu")).id;
        this.billStatus = JSON.parse(
          localStorage.getItem("openAllOrderListSu")
        ).status;
        let vm = this;
        this.loading = true;
        let getData = (data) => {
          this.returnOrder = data.Results.returnNotes;
          this.items = data.Results.orders;
        };
        $.api_call(
          "api.Bill.findOrderByBillIdBySupplier",
          {
            billId: JSON.parse(localStorage.getItem("openAllOrderListSu")).id,
          },
          function (r) {
            vm.loading = false;
            if (r.ErrorCode == "9999") {
              getData(r.Data);
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(vm);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }
    }
  },
  methods: {
    showStatu(val) {
      //显示订单状态
      let txt = "";
      if (!val) return;
      this.returnStatus.forEach((e) => {
        if (e.val == val) txt = e.name;
      });
      return txt;
    },
    goToOrder(code) {
      let routeData = this.$router.resolve({
        path: "order-manager",
        query: { code: code },
      });
      window.open(routeData.href, "_blank");
    },
    close() {
      window.close();
    },
    openExport(billId) {
      //打开导出模态框
      if (!billId) return;
      let vm = this;
      this.loading = true;
      let url;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      $.api_call("api.Bill.exportBySupplier", { billId }, (r) => {
        vm.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.addTask) {
            this.$store.commit("addTaskTimeFn", moment().unix());
            return;
          }
          url = r.Data.Results.url;
          openDownload(url);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-heard {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.list-body {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.05);
}

.purchase-img-wrap .pos-relative {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.purchase-img-wrap .pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  transform: scale(0.9, 0.9);
}
</style>